import { REST_API } from "../env/config";

export const login = async (username: string, password: string): Promise<string> => {
  try {
    const response = await fetch(`${REST_API}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
    const data = await response.json();
    if (response.ok && data.token) {
      return data.token;
    } else {
      return Promise.reject(new Error("Login failed: " + (data.error || "Unknown error")));
    }
  } catch (err) {
    return Promise.reject(new Error("Error connecting to server"));
  }
};
